import React, { useEffect, useState, useRef } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json"; // Ensure the path is correct

const D03PieChart1 = ({ filterCriteria }) => {
  const [favorableCount, setFavorableCount] = useState(0);
  const [neutralCount, setNeutralCount] = useState(0);
  const [unfavorableCount, setUnfavorableCount] = useState(0);
  const [noResponseCount, setNoResponseCount] = useState(0);
  // Use ref instead of state for the chart instance to avoid render loops
  const chartRef = useRef(null);
  
  // Process data based on filter criteria
  useEffect(() => {
    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        if (filterCriteria[key].length === 0) {
          return true; // If no filter is selected for this key, include all items
        }
        return filterCriteria[key].includes(item[key]);
      });
    };

    const filteredData = jsonData.filter(filterData);

    let favorable = 0;
    let neutral = 0;
    let unfavorable = 0;
    let noResponse = 0;

    filteredData.forEach((response) => {
      const { MQ0026 } = response;

      if (MQ0026 === 4 || MQ0026 === 5) {
        favorable++;
      } else if (MQ0026 === 3) {
        neutral++;
      } else if (MQ0026 === 1 || MQ0026 === 2) {
        unfavorable++;
      } else {
        noResponse++;
      }
    });

    setFavorableCount(favorable);
    setNeutralCount(neutral);
    setUnfavorableCount(unfavorable);
    setNoResponseCount(noResponse);
  }, [filterCriteria]);

  // Initialize and update chart
  useEffect(() => {
    const optionsPie1 = {
      series: [favorableCount, neutralCount, unfavorableCount, noResponseCount],
      labels: ["Favorable", "Neutral", "Unfavorable", "No Response"],
      colors: ["#499894", "#f1ce63", "#f28e2b", "#bab0ac"],
      chart: {
        type: "pie",
        toolbar: {
          show: true,
        },
        height: 300 // Fixed height instead of percentage
      },
      grid: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
      plotOptions: {
        pie: {
          dataLabels: {
            offset: -8,
            minAngleToShowLabel: 10
          },
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: "12px", 
          fontWeight: 'normal'
        },
        formatter: function(val) {
          return val.toFixed(1) + "%";
        }
      },
      legend: {
        position: "bottom",
        fontSize: '12px',
        horizontalAlign: 'center',
        itemMargin: {
          horizontal: 8,
          vertical: 0
        }
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function(val) {
            return val;
          }
        }
      }
    };

    const chartContainer = document.querySelector("#pie-1");
    
    // Check if chart already exists
    if (chartRef.current) {
      // Update existing chart
      chartRef.current.updateOptions(optionsPie1);
    } else if (chartContainer) {
      // Create new chart
      chartRef.current = new ApexCharts(chartContainer, optionsPie1);
      chartRef.current.render();
    }

    // Add window resize handler
    const handleResize = () => {
      if (chartRef.current) {
        chartRef.current.updateOptions({
          chart: {
            width: '100%'
          }
        }, false, true);
      }
    };

    window.addEventListener('resize', handleResize);

    // Clean up the chart and event listener on component unmount
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
      window.removeEventListener('resize', handleResize);
    };
  }, [favorableCount, neutralCount, unfavorableCount, noResponseCount]); // Removed chartInstance from dependencies

  return (
    <div style={{ width: '100%', height: '350px' }}>
      <div id="pie-1" style={{ width: '100%', height: '100%' }}></div>
    </div>
  );
};

export default D03PieChart1;